import { GlobalState } from "src/reducers";

export const selectMarketplaceOpenBuy = (
    state: GlobalState,
    openBuyId: number | undefined
) => {
    return openBuyId ? state.entities.adminOpenBuys.byId[openBuyId] : null;
};
